import { PageData, PageDataParams } from './page-data';
import { PageType, RawIntroPageData } from '../common/page-data';

export class IntroData extends PageData {
  private _introText: string;

  public get introText(): string {
    return this._introText;
  }

  public get pageType(): PageType {
    return PageType.Banner;
  }

  public get rawData(): RawIntroPageData {
    return this._rawPageData as RawIntroPageData;
  }

  public constructor(params: PageDataParams) {
    super(params);

    const { rawPageData } = params;

    this._introText = (rawPageData as RawIntroPageData).data.markdown;
  }
}
